import React from 'react';
import './AboutTeacher.css';
import ProfileDisplay from '../ProfileDisplay/ProfileDisplay';

function AboutTeacher({instructor, instructor_title, about_teacher}) {
  return (
    <div className='about-teacher-container'>
      <ProfileDisplay 
        instructor={instructor}
        instructor_title={instructor_title}/>
      <p className='about-teacher-title-text'>About Teacher</p>
      <p className='about-teacher-title-description'>{about_teacher}</p>
      <p className='about-teacher-view-more'>View More About Techer</p>
    </div>
  )
}

export default AboutTeacher